module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f466-1f3fd.d85a08e1.svg";